import qs from 'qs';

import {
  OBJECT_TYPE_ASSETS,
  OBJECT_TYPE_COLLECTIONS,
  OBJECT_TYPE_SAVED_SEARCHES,
  type ObjectType,
} from '@iconik-io/iconik-api/src/types/object_types';

/**
 * @deprecated
 */
export const getObjectLinkDeprecated = (id: string, type: ObjectType): string =>
  `/${type === OBJECT_TYPE_ASSETS ? 'asset' : 'collection'}/${id}`;

const objectTypeUrlMap: Record<string, string> = {
  [OBJECT_TYPE_ASSETS]: '/asset',
  [OBJECT_TYPE_COLLECTIONS]: '/collection',
  [OBJECT_TYPE_SAVED_SEARCHES]: '/savedsearch',
};

// Both url maps carry only part of the union and fall through to '' for the
// rest, so a type they do not list is a link that cannot be built.
export function getRegularObjectLink(
  id: string,
  objectType: ObjectType,
  versionId?: string,
): string {
  if (!objectTypeUrlMap[objectType]) {
    return '';
  }
  let objectLink = `${objectTypeUrlMap[objectType]}/${id}`;
  if (versionId) {
    objectLink += `/v/${versionId}`;
  }
  return objectLink;
}

const objectTypeShareUrlMap: Record<string, string> = {
  [OBJECT_TYPE_ASSETS]: '/share/assets',
  [OBJECT_TYPE_COLLECTIONS]: '/share/collections',
};

export function getShareObjectLink(
  id: string,
  objectType: ObjectType,
  versionId?: string,
): string {
  if (!objectTypeShareUrlMap[objectType]) {
    return '';
  }
  let objectLink = `${objectTypeShareUrlMap[objectType]}/${id}`;
  if (versionId) {
    objectLink += `/v/${versionId}`;
  }

  // on share pages, we keep the query params
  // https://linear.app/iconik/issue/FE-863/navigating-to-a-share-asset-from-a-share-collection-loses-the-share
  const { hash, object_id, object_type, per_page } = qs.parse(
    window.location.href.split('?')[1],
  );

  objectLink += `?${qs.stringify({ object_id, object_type, hash, per_page })}`;

  return objectLink;
}

export function getObjectLink(
  isSharePage: boolean,
  id: string,
  objectType: ObjectType,
  versionId?: string,
): string {
  return isSharePage
    ? getShareObjectLink(id, objectType, versionId)
    : getRegularObjectLink(id, objectType, versionId);
}
